export function LogoMark({ size = 32 }: { size?: number }) {
  return (
    <svg width={size} height={size} viewBox="0 0 32 32" fill="none" aria-hidden>
      <rect width="32" height="32" fill="#FF5500" />
      <rect x="3.5" y="15" width="8" height="2" fill="#1A1818" />
      <rect x="20.5" y="15" width="8" height="2" fill="#1A1818" />
      <rect x="15" y="3.5" width="2" height="8" fill="#1A1818" />
      <rect x="15" y="20.5" width="2" height="8" fill="#1A1818" />
      <circle cx="16" cy="16" r="5" stroke="#1A1818" strokeWidth="1.75" fill="none" />
    </svg>
  );
}

export function LogoWordmark({ light = false }: { light?: boolean }) {
  const nameColor = light ? "#FFFFFF" : "#1A1818";
  const subColor = light ? "rgba(255,255,255,0.45)" : "rgba(26,24,24,0.45)";
  return (
    <div className="flex items-center gap-2.5">
      <LogoMark size={32} />
      <div className="flex flex-col leading-none">
        <span
          className="font-display font-black text-xl tracking-tight"
          style={{ color: nameColor, lineHeight: 1 }}
        >
          ONIN
        </span>
        <span
          className="text-[9px] font-bold tracking-[0.28em] uppercase mt-[3px]"
          style={{ color: subColor }}
        >
          Digital
        </span>
      </div>
    </div>
  );
}
